import { ReactNode } from "react";
import { Box } from "@mui/material";
import { getIsImpersonate } from "../utils/storage";
import ImpersonateHeader from "./ImpersonateHeader";

interface ImpersonateWrapperProps {
  children: ReactNode;
}

const IMPERSONATE_HEADER_HEIGHT = 36;

const ImpersonateWrapper = ({ children }: ImpersonateWrapperProps) => {
  const isImpersonate = getIsImpersonate();

  if (!isImpersonate) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        "--impersonate-offset": `${IMPERSONATE_HEADER_HEIGHT}px`,
        paddingTop: `${IMPERSONATE_HEADER_HEIGHT}px`,
        minHeight: "100vh",
        boxSizing: "border-box",
        "& .MuiAppBar-root": {
          top: `${IMPERSONATE_HEADER_HEIGHT}px`,
        },
      }}
    >
      <ImpersonateHeader />
      {children}
    </Box>
  );
};

export default ImpersonateWrapper;
